import TabAnexosService from "./TabAnexosService";

export default {
  mixins: [TabAnexosService],
  props: {
    idRnpPrestador: {
      type: [String, Number],
      default: -1
    }
  },
  data() {
    return {
      listaArquivos: [],
      loading: false
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.inicializarListagemAnexos().finally(() => {
        this.sleep(150).then(() => {
          this.loading = false;
        });
      });
    },
    inicializarListagemAnexos() {
      return new Promise((resolve, reject) => {
        this.getArquivosAnexo(this.idRnpPrestador)
          .then(res => {
            this.montarArquivos(res.data);
            if (res.data.length === 0) {
              this.$emit("lista-arquivos-vazio", this.mostrarSingular);
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    montarArquivos(arquivos) {
      this.listaArquivos = [];

      console.log("tab_anexos_mixins-lista-arquivos", arquivos);
      arquivos.forEach(e => {
        const {
          usuarioUpload: usuario,
          usuarioAlteracao: usuarioAlteracao,
          uuid,
          id,
          arquivo: nomeArquivo,
          baixavel,
          dtAlteracao: dataAlteracao,
          dtUpload: dataEnvio,
          status: { chave: statusChave, descricao: mensagemStatus },
          descricao: descricao
        } = e;
        const objetoArquivo = {
          tipoArquivo: statusChave,
          objetoArquivo: {
            nomeArquivo,
            tamanhoArquivo: "",
            usuario,
            usuarioAlteracao,
            descricao,
            dataEnvio: dataEnvio
              ? this.$helpers.formatadorHorario(dataEnvio)
              : "",
            dataAlteracao: dataAlteracao
              ? this.$helpers.formatadorHorario(dataAlteracao)
              : "",
            barraProgresso: 0,
            baixavel,
            mensagemStatus,
            id,
            uuid,
            mostrarIconeExcluir: this.mostrarSingular
          }
        };
        this.listaArquivos.push(objetoArquivo);
      });
    },
    /**
     *
     * @param {{
     *   formData: FormData,
     *   objetoArquivoUpload: {
     *     tipoArquivo: String,
     *     objetoArquivo: {
     *       nomeArquivo: String,
     *       tamanhoArquivo: String,
     *       barraProgresso: Number,
     *       descricao: String
     *     }
     *   }
     * }} objetoUpload
     */
    uploadArquivo(objetoUpload) {
      const { formData, objetoArquivoUpload } = objetoUpload;

      this.listaArquivos.unshift(objetoUpload.objetoArquivoUpload);

      this.sleep(500).then(() => {
        this.postUploadArquivo(formData, this.idRnpPrestador, porcentagem => {
          objetoArquivoUpload.objetoArquivo.barraProgresso = porcentagem;
          console.log("objetoArquivoUpload", objetoArquivoUpload);
        })
          .then(() => {
            this.sleep(150).then(() => {
              this.init();
              this.$emit("iniciar-prestador");
            });
          })
          .catch(err => {
            if (err.cancelado) {
              this.sleep(200).then(() => {
                this.init();
              });
              return;
            }

            err.then(({ response }) => {
              console.log("data.details", response.data.details);
              this.$store.commit("setErro", {
                mostrarErro: true,
                titulo: "Oops, algo deu errado.",
                codigoErro: response.data.status,
                mensagemErro: response.data.details
              });
              objetoArquivoUpload.objetoArquivo.barraProgresso = 0;
              this.$store.commit("setCallbackFecharErro", () => {
                this.listaArquivos.shift();
              });
            });
          });
      });
    },

    baixarArquivo(uuid) {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadArquivo(uuid)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"],
            console.log(res)
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    salvarDescricaoAnexo(ObjetoAcao, descricao) {
      const { id } = ObjetoAcao;

      console.log(ObjetoAcao);
      this.$store.commit("setLoadingModal", true);

      this.putDescricaoAnexo(id, descricao)
        .then(() => {
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.init();
          });
          this.$store.commit(
            "setSubtituloSucesso",
            "Descrição salva com sucesso!"
          );
          this.$store.commit("setMostrarSucessoModal", true);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },

    /// FLUXO ANALISTA

    deletarArquivo(ObjetoAcao) {
      const { id, uuid } = ObjetoAcao;

      this.$store.commit("setLoadingModal", true);

      this.deleteArquivo(id, uuid)
        .then(() => {
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.init();
          });
          this.$store.commit(
            "setSubtituloSucesso",
            "Arquivo deletado com sucesso!"
          );
          this.$store.commit("setMostrarSucessoModal", true);
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  }
};
